import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { usePageContext } from 'application/contexts/PageContext';
import { Navigation } from 'designsystem/components/3-organisms/Navigation';
import { LayoutStyle } from 'features/Layouts/Layout/LayoutFeature';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { LinkFeature } from '../Link';
interface SiblingNavigationFeatureProps {
	siblingNavigation: Navigation.NavigationItem[];
}

export const SiblingNavigationFeature: React.FC<SiblingNavigationFeatureProps> = ({ siblingNavigation }) => {
	const dictionary = useDictionaryContext();
	const pageContext = usePageContext();
	const router = useRouter();
	const layout = (router?.query?.layout as LayoutStyle) ?? null;
	const { parent, content, url: currentUrl } = pageContext ?? {};
	const heading = parent.name;
	const aboutMoreText = dictionary.getAction('MoreAbout');

	const [navigationHeading, setNavigationHeading] = useState(heading);

	useEffect(() => {
		const aboutMoreTextWords = aboutMoreText.split(' ');
		const headingWords = heading.split(' ');
		if (aboutMoreTextWords[aboutMoreTextWords.length - 1].toLowerCase() === headingWords[0].toLowerCase()) {
			headingWords.splice(0, 1);
			setNavigationHeading(headingWords.join(' '));
		}
	}, [aboutMoreText, heading]);

	if (content?.hideSiblingMenu) return <></>;

	return siblingNavigation?.length > 1 && !content?.umbracoNaviHide && layout !== 'simple' ? (
		<Navigation
			data-tracking-id="siblingNavigation"
			style="list"
			heading={navigationHeading}
			isGerman={pageContext.url.includes('/de-de/')}
			navigationItems={siblingNavigation
				?.filter((item) => !item.hidden)
				?.map((link) => {
					const isCurrent = currentUrl === link.url;
					return {
						...link,
						active: isCurrent,
						link: <LinkFeature {...link} />,
					};
				})}
			className="u-print-none"
			aboutMoreText={dictionary.getAction('MoreAbout')}
		/>
	) : (
		<></>
	);
};
